import script from "./ResourcesContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourcesContent.vue?vue&type=script&setup=true&lang=js"

import "./ResourcesContent.vue?vue&type=style&index=0&id=f86e56b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f86e56b6"]])

export default __exports__